<section *ngIf="loading">
  <h2>Loading...</h2>
  <mat-progress-bar mode="indeterminate" color="primary" aria-label="Loading...">
  </mat-progress-bar>
</section>

<div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start" *ngIf="!loading">
  <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="begin">
    <h2>
      <span *ngIf="interactionDialog.id == 0"><mat-icon>add</mat-icon> Add</span>
      <span *ngIf="interactionDialog.id > 0"><mat-icon>add</mat-icon> Edit</span> Interaction
    </h2>
  </div>
  <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="end">
    <button mat-button mat-dialog-close="Cancel" aria-label="Cancel" [disabled]='processing || loading'>Close</button>
  </div>
</div>
<mat-dialog-content>
  <div *ngIf="!loading && !processing">
    <mat-card fxFlex="100" fxFlex.lt-sm="100">
      <mat-card-content>
        <form #form="ngForm" [formGroup]="interactionForm" class="form-field-full">
          <div fxLayout="row wrap" fxLayoutGap="8px grid">
            <div fxFlex="25" fxFlex.lt-sm="100" fxLayoutAlign="start center">
              <mat-checkbox formControlName="approvedByStaff"> &nbsp; Approve Interaction</mat-checkbox>
            </div>
            <div fxFlex="25" fxFlex.lt-sm="100">
              <mat-form-field appearance="standard">
                <mat-label>Interaction Type</mat-label>
                <mat-select formControlName="type">
                  <mat-option *ngFor="let item of contactTypes" value="{{item}}">{{item}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div fxLayout="row wrap" fxLayoutGap="8px grid">
            <div fxFlex="50" fxFlex.lt-sm="100">
              <mat-form-field appearance="standard">
                <mat-label>Comments</mat-label>
                <textarea rows="3" cols="100" placeholder="comment" formControlName="comment"
                  value="{{interactionForm.value.comment}}" matInput></textarea>
              </mat-form-field>
            </div>
            <div fxFlex="50" fxFlex.lt-sm="100">
              <mat-form-field appearance="standard">
                <mat-label>Result</mat-label>
                <textarea rows="3" cols="100" placeholder="result" formControlName="result"
                  value="{{interactionForm.value.result}}" matInput></textarea>
              </mat-form-field>
            </div>
          </div> 
          <div fxLayout="row wrap" fxLayoutGap="8px grid">
            <div fxFlex="50" fxFlex.lt-sm="100">

              <button type="submit" id="submitButtonSearch" (click)="save()" mat-raised-button color="primary"
                title="Save" [disabled]='loading || processing'>Save</button>
            </div>
          </div>
        </form>

      </mat-card-content>
    </mat-card>
  </div>
</mat-dialog-content>